import "react-native-gesture-handler";
import React, { useEffect, useState } from "react";
import { StyleSheet, Text, View } from "react-native";
import firebase from "firebase";
import { observer } from "mobx-react";
import firebaseConfig from "./config/firebaseConfig";
import { NavigationContainer } from "@react-navigation/native";
import RootNavigator from "./routes/RootNavigator";
import { navigationRef } from "./routes/Global";
import AppLoading from "expo-app-loading";
import loadAssets from "./functions/loadAssets";
import * as Font from "expo-font";
import state from "./store/Store";
import fonts from "./constants/fonts";
import Spinner from "react-native-loading-spinner-overlay";
import CustomSpinner from "./components/CustomSpinner";
import authListener from "./networking/api/auth/authListener";
import FlashMessage from "react-native-flash-message";
import Store from "./store/Store";
import Modal from "react-native-modalbox";
import { ActivityIndicator } from "react-native";
import { Easing } from "react-native-reanimated";
import { enableScreens } from "react-native-screens";
// enableScreens();
if (!firebase.apps.length) firebase.initializeApp(firebaseConfig);

const App = observer(() => {
  const { uid, loading } = Store;

  const [loaded] = Font.useFonts(fonts);
  const [isReady, setReady] = useState(false);
  const [authReady, setAuthReady] = useState(false);

  useEffect(() => {
    authListener((e) => setAuthReady(e));
  }, []);

  if (!isReady || !loaded || !authReady) {
    return <AppLoading startAsync={loadAssets} onFinish={() => setReady(true)} onError={console.warn} />;
  }

  return (
    <View style={styles.container}>
      <Modal
        swipeToClose={false}
        easing={Easing.linear}
        isOpen={loading}
        animationDuration={0}
        style={styles.loader}
        useNativeDriver={false}>
        <ActivityIndicator animating size="large" />
      </Modal>

      <NavigationContainer ref={navigationRef} linking={{ enabled: true }}>
        <RootNavigator uid={uid} />
      </NavigationContainer>
      <FlashMessage position="bottom" />
    </View>
  );
});

export default App;

const styles = StyleSheet.create({
  loader: {
    backgroundColor: "#00000050",
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },
  container: {
    flex: 1,
    backgroundColor: "#fff",
  },
});
